"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const emailRegex = /^[-!#$%&'*+\/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+\/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-*\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
class ValidationHelper {
}
exports.default = ValidationHelper;
ValidationHelper.isEmailValid = (email) => {
    if (!email) {
        return false;
    }
    if (email.length > 254) {
        return false;
    }
    const valid = emailRegex.test(email);
    if (!valid) {
        return false;
    }
    const accountParts = email.split("@");
    if (accountParts[0].length > 64) {
        return false;
    }
    const domainParts = accountParts[1].split(".");
    return !domainParts.some(part => part.length > 63);
};
ValidationHelper.validateUser = (username, password, memberOf) => {
    let isValid = false;
    if (username && password) {
        isValid = ValidationHelper.isEmailValid(username) &&
            password.length > 7;
    }
    if (isValid && memberOf !== undefined) {
        isValid = Array.isArray(memberOf);
    }
    return isValid;
};
ValidationHelper.validateNode = (nodeName, location) => {
    let isValid = false;
    if (nodeName && location) {
        isValid = nodeName.length > 4 && nodeName.length < 25
            && location.length > 0 && (location === null || location === void 0 ? void 0 : location.length) < 10;
    }
    return isValid;
};
//# sourceMappingURL=ValidationHelper.js.map